<template>
  <div class="expireat">
    <div
      class="expireat--item"
      :style="{ '--bg-c': tag.package === 'basic' || tag.package === 'expired' ? 'gray' : 'red' }"
      v-for="(tag, index) in tagLists"
      :key="`tag-${index}`"
    >
      {{ tag.text }}
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  props: {
    bot: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    tagLists() {
      let tags = []
      if (
        this.bot.advanced_expireat &&
        this.bot.business_expireat &&
        this.bot.expireat &&
        (this.bot.advanced_expireat === this.bot.business_expireat) === this.bot.expireat &&
        this.countDate(this.bot.advanced_expireat) > 0 &&
        this.countDate(this.bot.advanced_expireat) < 8
      ) {
        tags.push({
          package: 'business',
          text: this.$t('Business remain day(s)', {
            num: this.countDate(this.bot.business_expireat)
          })
        })
      } else if (
        this.bot.advanced_expireat &&
        this.bot.business_expireat &&
        this.bot.advanced_expireat === this.bot.business_expireat &&
        this.countDate(this.bot.advanced_expireat) > 0 &&
        this.countDate(this.bot.advanced_expireat) < 8
      ) {
        tags.push({
          package: 'business',
          text: this.$t('Business remain day(s)', {
            num: this.countDate(this.bot.business_expireat)
          })
        })
      } else if (
        this.bot.advanced_expireat &&
        this.bot.expireat &&
        this.bot.advanced_expireat === this.bot.expireat &&
        this.countDate(this.bot.advanced_expireat) > 0 &&
        this.countDate(this.bot.advanced_expireat) < 8
      ) {
        tags.push({
          package: 'advanced',
          text: this.$t('Advanced remain day(s)', {
            num: this.countDate(this.bot.advanced_expireat)
          })
        })
      } else if (
        this.bot.business_expireat &&
        this.bot.expireat &&
        this.bot.business_expireat === this.bot.expireat &&
        this.countDate(this.bot.business_expireat) > 0 &&
        this.countDate(this.bot.business_expireat) < 8
      ) {
        tags.push({
          package: 'business',
          text: this.$t('Business remain day(s)', {
            num: this.countDate(this.bot.business_expireat)
          })
        })
      } else if (!this.bot.advanced_expireat && this.bot.expireat === this.bot.registerat) {
        tags.push({ package: 'basic', text: this.$t('basic_package_free') })
      } else if (
        (!this.bot.advanced_expireat &&
          !this.bot.business_expireat &&
          this.bot.expireat &&
          this.countDate(this.bot.expireat) === 0) ||
        (!this.bot.business_expireat &&
          this.bot.advanced_expireat &&
          this.countDate(this.bot.advanced_expireat) === 0 &&
          this.bot.expireat &&
          this.countDate(this.bot.expireat) === 0) ||
        (!this.bot.advanced_expireat &&
          this.bot.business_expireat &&
          this.countDate(this.bot.business_expireat) === 0 &&
          this.bot.expireat &&
          this.countDate(this.bot.expireat) === 0) ||
        (this.bot.advanced_expireat &&
          this.countDate(this.bot.advanced_expireat) === 0 &&
          this.bot.business_expireat &&
          this.countDate(this.bot.business_expireat) === 0 &&
          this.bot.expireat &&
          this.countDate(this.bot.expireat) === 0)
      ) {
        tags.push({ package: 'expired', text: this.$t('package_expired') })
      } else {
        if (
          this.bot.business_expireat &&
          this.countDate(this.bot.business_expireat) < 8 &&
          this.countDate(this.bot.business_expireat) > 0
        ) {
          tags.push({
            package: 'business',
            text: this.$t('Business remain day(s)', {
              num: this.countDate(this.bot.business_expireat)
            })
          })
        }
        if (
          this.bot.advanced_expireat &&
          this.countDate(this.bot.advanced_expireat) < 8 &&
          this.countDate(this.bot.advanced_expireat) > 0
        ) {
          tags.push({
            package: 'advanced',
            text: this.$t('Advanced remain day(s)', {
              num: this.countDate(this.bot.advanced_expireat)
            })
          })
        }
        if (
          this.bot.expireat &&
          this.countDate(this.bot.expireat) < 8 &&
          this.countDate(this.bot.expireat) > 0
        ) {
          tags.push({
            package: 'premium',
            text: this.$t('Premium remain day(s)', {
              num: this.countDate(this.bot.expireat)
            })
          })
        }
      }
      return tags
    }
  },
  methods: {
    countDate(expireat) {
      let a = dayjs(expireat)
      let b = dayjs()
      return a.diff(b, 'days') > 0 ? a.diff(b, 'days') : 0
    },
    checkOutOfTime(expireat) {
      let a = dayjs(expireat)
      let b = dayjs()
      return b.diff(a, 'days') > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.expireat {
  position: absolute;
  z-index: 1;
  left: 0px;
  bottom: 0px;
}

.expireat--item {
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 5px 5px 5px 0px;
  background-color: var(--bg-c);
  margin-bottom: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/TagAllbot.vue